document.addEventListener('DOMContentLoaded', function() {
  // Only run on cart page
  if (!window.location.pathname.includes('/cart')) return;

  // Settings
  const freeGiftProductHandle = 'free-gift'; // REPLACE with your product handle
  const minimumCartAmount = 150000; // $50 in cents
  const popup = document.getElementById('free-gift-popup');
  const closeBtn = document.getElementById('close-popup');
  const body = document.body;

  // Close popup and refresh
  closeBtn.addEventListener('click', function() {
    popup.style.display = 'none';
    body.classList.remove('popup-open');
    window.location.reload();
  });

  // Find gift item in cart
  async function findGiftInCart(cart, productId) {
    return cart.items.find(item => item.product_id === productId);
  }

  // Add gift to cart
  async function addGiftToCart(product) {
    try {
      const variantId = product.variants[0].id;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: { '_free_gift': 'true' }
          }]
        })
      });
      return true;
    } catch (error) {
      console.error('Error adding gift:', error);
      return false;
    }
  }

  // Remove gift from cart
  async function removeGiftFromCart(giftItem) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 0
        })
      });
      return true;
    } catch (error) {
      console.error('Error removing gift:', error);
      return false;
    }
  }

  // Enhanced cart check with forced UI update
  async function checkFreeGift() {
    try {
      const [cartRes, productRes] = await Promise.all([
        fetch('/cart.js'),
        fetch(`/products/${freeGiftProductHandle}.js`)
      ]);
      
      const [cart, product] = await Promise.all([
        cartRes.json(),
        productRes.json()
      ]);
      
      const giftItem = await findGiftInCart(cart, product.id);
      const hasGift = !!giftItem;
      const qualifiesForGift = cart.total_price >= minimumCartAmount;
      
      // Case 1: Qualifies and doesn't have gift - add it
      if (qualifiesForGift && !hasGift) {
        document.getElementById('free-gift-image').src = product.featured_image;
        document.getElementById('free-gift-name').textContent = product.title;
        document.querySelector('#free-gift-price span:first-child').textContent = 
          `$${(product.price / 100).toFixed(2)}`;
        
        popup.style.display = 'flex';
        body.classList.add('popup-open');
        await addGiftToCart(product);
      } 
      // Case 2: Doesn't qualify but has gift - remove it
      else if (!qualifiesForGift && hasGift) {
        console.log("doesn't qualify...", giftItem)
        await removeGiftFromCart(giftItem);

        window.location.reload();
        // Force UI update for all themes
        // document.querySelector(`[data-variant-id="${giftItem.variant_id}"]`)?.remove();
        // document.querySelector(`[data-id="${giftItem.key}"]`)?.remove();
        // document.querySelector(`[data-line-item-key="${giftItem.key}"]`)?.remove();
      }
    } catch (error) {
      console.error('Error:', error);
    }
  }

  // Initialize
  checkFreeGift();
  
  // Universal cart change detection
  setInterval(checkFreeGift, 1000); // Check every second
  
  // Special handling for quantity inputs
  document.querySelector('.cart')?.addEventListener('change', function(e) {
    if (e.target.classList.contains('cart__quantity') || 
        e.target.classList.contains('cart-item__quantity') ||
        e.target.name === 'updates[]') {
      setTimeout(checkFreeGift, 300);
    }
  });

  // Handle remove buttons
  document.querySelector('.cart')?.addEventListener('click', function(e) {
    if (e.target.classList.contains('cart__remove') || 
        e.target.closest('.cart__remove') || 
        e.target.classList.contains('cart-item__remove')) {
      setTimeout(checkFreeGift, 300);
    }
  });
});